var exports = {
  "nf": "xae11d333--2c94db--link",
  "wm": "xae11d333--2c94db--logo",
  "Qq": "xae11d333--2c94db--text",
};

module.exports = exports;
